module.exports = __webpack_public_path__ + "img/plus.b44b47f5.svg";